import React from "react";
import "./styles.scss";

const Dropdown = ({ showDropdown, children, className }) => {
  return (
    <div
      className={`dropdown-menu
            ${showDropdown && "dropdown-menu__show"}
            dropdown-menu__${className}`}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabIndex={-1}
    >
      {children}
    </div>
  );
};

export default Dropdown;
